<div class="content">
  <h3>Sign in to view your dashboard</h3>
  <ddmgt-login (ddmgt-login-completed)="handleLoginCompleted()"></ddmgt-login>
</div>